'use client'
// =============================================================================
// MemTab — onglet MEM de l'AI Command Center (ex-onglet "MÉMOIRE"). Remplace
// l'ancien MemoryTab, dont les 3 blocs (MÉMOIRE ACTIVE, MÉMOIRE VECTORIELLE,
// RELATIONS) étaient figés (données jamais mises à jour depuis leur valeur
// initiale codée en dur).
// =============================================================================
import { MemorySummary } from '../widgets/MemorySummary'

export function MemTab() {
  return <MemorySummary />
}
